import { useState,useRef, useEffect } from 'react'
import * as locales from 'react-date-range/dist/locale';
import { iconList } from '../../views/share/components/iconSVG';
import packImg from '../../assets/pictures/BannerTours.png'

const Paquetes = () => {

    const paquetes = [

        {
            id: 1,
            img:packImg,
            title: "Eje Cafetero, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 599.000 COP"
        }, {
            id: 2,
            img:packImg,
            title: "Santander, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 599.000 COP"
        }, {
            id: 3,
            img:packImg,
            title: "Boyaca, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 875.000 COP"
        }, {
            id: 4,
            img:packImg,
            title: "Llanos Orientales, Col",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 845.000 COP"
        }, {
            id: 5,
            img:packImg,
            title: "Desierto de la Tatacoa, Col",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 699.000 COP"
        }, {
            id: 6,
            img:packImg,
            title: "Cartagena, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.175.000 COP"
        }, {
            id: 7,
            img:packImg,
            title: "Santa Marta, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 839.000 COP"
        }, {
            id: 8,
            img:packImg,
            title: "San Andres, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.199.000 COP"
        }, {
            id: 9,
            img:packImg,
            title: "Coveñas, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.030.000 COP"
        }, {
            id: 10,
            img:packImg,
            title: "La Guajira, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.460.000 COP"
        }, {
            id: 11,
            img:packImg,
            title: "Amazonas, Colombia",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.375.000 COP"
        }, {
            id: 12,
            img:packImg,
            title: "Punta Cana, Republica Dom",
            descripcion: "Salida desde Medellin",
            stars:8.5,
            icon:iconList.IconBus,
            price: "$ 1.375.000 COP"
        }
    ]


    const originCityRef = useRef() 
    const destinyCityRef = useRef()
    const roundTripPackages = useRef()
    const goinRef = useRef()

    const [background, setBackground] = useState(1)
    const [calendar, setcalendar] = useState(false)
    const [calendarTwo, setCalendarTwo] = useState(false)
    const [typeT, setTypeT] = useState(0)

    const [services, setServices] = useState(paquetes)
    const itemsForPage = 8
    const [topic, setTopic] = useState([...services].splice(0, itemsForPage))
    const [currentPage, setCurrentPage] = useState(0)
    const [mostrarNext, setMostrarNext] = useState(true)
 
    const [cityDestiny, setCityDestiny] = useState(false)
    const [cityOrigin, setCityOrigin] = useState(false)

    const [dated, setDated] = useState(null);
    const [date, setDate] = useState([
        {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        }
    ]);

    const nameMapper = {

        de: 'German',
        enGB: 'English (United Kingdom)',
        enUS: 'English (United States)',
        es: 'Spanish',

    };

    const localeOptions = Object.keys(locales)
        .map(key => ({
            value: key,
            label: `${key} - ${nameMapper[key] || ''}`
        }))
        .filter(item => nameMapper[item.value]);

    const [locale, setLocale] = useState('es');



    const selectTypeResercation = (type) => {
        type === 1 ? setBackground(type) : setBackground(type)
    }

    const nextHandler = () => {
        const totalElementos = services.length;

        const nextPage = currentPage + 1

        const firtsIndex = nextPage * itemsForPage
        if (firtsIndex >= totalElementos) {
            setMostrarNext(false)
            return;
        }


        setCurrentPage(nextPage)
        setTopic([...services].splice(firtsIndex, itemsForPage))

    }
    const prevHandler = () => {
        setMostrarNext(true)
        const prevPage = currentPage - 1

        if (prevPage < 0) return;

        const firtsIndex = prevPage * itemsForPage

        setTopic([...services].splice(firtsIndex, itemsForPage))
        setCurrentPage(prevPage)
    }

    useEffect(() => {
        function handleClickOutside(event) {
          if (originCityRef.current && !originCityRef.current.contains(event.target)) {
            setCityOrigin(false)
        }
          if (destinyCityRef.current && !destinyCityRef.current.contains(event.target)) {
            setCityDestiny(false)
          }
          if (roundTripPackages.current && !roundTripPackages.current.contains(event.target)) {
            setCalendarTwo(false)
          }
          if (goinRef.current && !goinRef.current.contains(event.target)) {
            setcalendar(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [])



    return {
        paquetes,
        nextHandler,
        prevHandler,
        selectTypeResercation,
        background,
        setBackground,
        calendar,
        setcalendar,
        calendarTwo,
        setCalendarTwo,
        typeT,
        setTypeT,
        services,
        setServices,
        itemsForPage,
        topic,
        setTopic,
        currentPage,
        setCurrentPage,
        mostrarNext,
        setMostrarNext,
        dated,
        setDated,
        date,
        setDate,
        nameMapper,
        localeOptions,
        locale,
        setLocale,
        cityDestiny, 
        setCityDestiny,
        cityOrigin,
        setCityOrigin,
        originCityRef,
        destinyCityRef,
        roundTripPackages,
        goinRef
    }
}

export default Paquetes



